export default __webpack_public_path__ + "static/media/busy.63f96cef.svg";